module.exports = __webpack_public_path__ + "static/media/providerSilverTop2D.8b184e84.webp";